import React from 'react';
import './AboutUsVizyon.css';
import vizyon from "../../../assets/images/vizyon.jpg";


const AboutUsVizyon = () => {
  return (
    <section className="vizyon-section">
      <div className="vizyon-container">
        <div className="vizyon-image">
          <img src={vizyon} alt="Vizyonumuz" />
        </div>
        <div className="vizyon-text">
          <p className="vizyon-baslik">Vizyonumuz</p>
          <p className="vizyon-metin">
            Lingify olarak, iletişim kurma güçlüğü yaşayan herkesin, ihtiyaç duyduğu desteğe hızlı, kaliteli ve sürdürülebilir şekilde ulaşabildiği bir dünya hayal ediyoruz. Vizyonumuz; konuşma ve dil bozukluklarında dijital terapinin küresel ölçekte ilk başvuru noktası olmak. Teknolojiyi, sadece bir araç değil; toplumsal farkındalık, erken tanı, etkili terapi ve hak temelli bir sağlık yaklaşımı için bir dönüştürücü olarak kullanıyoruz. Türkiye'den dünyaya açılan öncü bir dijital sağlık girişimi olarak, alanın sınırlarını birlikte yeniden tanımlıyoruz.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutUsVizyon;
